import "@total-typescript/ts-reset";
import { setSentry } from "@mozioinc/logging";
import { captureException } from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import { getEnvs } from "./utils/env";
import { setLoggly } from "./utils/logging";
import { setOsano } from "./utils/osano";
import { setTranslation } from "./utils/translation";
import "@mozioinc/ui/src/index.css";
import { setWhiteLabel } from "./utils/white-label";

const {
  VERCEL_GIT_COMMIT_SHA,
  VERCEL_GIT_PREVIOUS_SHA,
  VERCEL_ENV,
  MOZIO_PUBLIC_SENTRY_DSN,
  MOZIO_PUBLIC_SENTRY_ORGANIZATION,
  MOZIO_PUBLIC_SENTRY_PROJECT_ID,
} = getEnvs();

window.APP_VERSION = APP_VERSION;
window.GIT_COMMIT_SHA = VERCEL_GIT_COMMIT_SHA;
window.GIT_PREVIOUS_SHA = VERCEL_GIT_PREVIOUS_SHA;
console.info("App version:", APP_VERSION);

setSentry({
  env: VERCEL_ENV,
  version: APP_VERSION,
  dsn: MOZIO_PUBLIC_SENTRY_DSN,
  organization: MOZIO_PUBLIC_SENTRY_ORGANIZATION,
  projectId: MOZIO_PUBLIC_SENTRY_PROJECT_ID,
});

Promise.resolve()
  .then(setWhiteLabel)
  .then(setTranslation)
  // setLoggly() must happen after setWhiteLabel() because it reads from white label. This is only required for dev mode.
  .then(setLoggly)
  .then(setOsano)
  .then(() =>
    ReactDOM.createRoot(document.querySelector("#root")!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    ),
  )
  .catch((error: Error) => {
    console.error(error);
    captureException(error);
    ReactDOM.createRoot(document.querySelector("#root")!).render(
      <React.StrictMode>Error</React.StrictMode>,
    );
  });
